import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { RenderLabPage } from "./-RenderLabPage"

const renderLabSearchSchema = z.object({
  view: z.enum(["create", "history"]).optional(),
  comparisonId: z.string().min(1).optional(),
})

export const Route = createFileRoute("/admin/render-lab")({
  validateSearch: (search) => renderLabSearchSchema.parse(search),
  component: RenderLabPage,
})
